module.exports = __webpack_public_path__ + "img/simbolo-outline-orange.a681f91b.svg";